module.exports = "/365FarmNet/dist/ownActivitiesIcons.e1bacb317fe040b4e04d42b05e622c1e.html";